var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import axios from 'axios';
var API_BASE_URL = 'http://localhost:3001';
// Main authenticated component
var AuthenticatedView = function () { return (_jsxs("div", { children: [_jsx("h1", { children: "FattureInCloud OAuth Example" }), _jsx("p", { children: "You are authenticated!" })] })); };
// Login page component
var LoginPage = function (_a) {
    var initiateOAuth = _a.initiateOAuth;
    return (_jsxs("div", { children: [_jsx("h1", { children: "FattureInCloud OAuth Example" }), _jsx("p", { children: "You need to login to use this app." }), _jsx("button", { onClick: initiateOAuth, children: "Login with FattureInCloud" })] }));
};
function App() {
    var _this = this;
    var _a = useState(null), isAuthenticated = _a[0], setIsAuthenticated = _a[1];
    useEffect(function () {
        checkAuthStatus();
    }, []);
    var checkAuthStatus = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("".concat(API_BASE_URL, "/auth/check"), { withCredentials: true })];
                case 1:
                    response = _a.sent();
                    setIsAuthenticated(response.data.authenticated);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error checking auth status:', error_1);
                    setIsAuthenticated(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var initiateOAuth = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            window.location.href = "".concat(API_BASE_URL, "/oauth/authorize");
            return [2 /*return*/];
        });
    }); };
    if (isAuthenticated === null) {
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsx(Router, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: isAuthenticated ? (_jsx(AuthenticatedView, {})) : (_jsx(Navigate, { to: "/login", replace: true })) }), _jsx(Route, { path: "/login", element: isAuthenticated ? (_jsx(Navigate, { to: "/", replace: true })) : (_jsx(LoginPage, { initiateOAuth: initiateOAuth })) })] }) }));
}
export default App;
